import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../hooks'
import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { InvoiceSettingsFormSchema } from '../../../../../../types/invoiceSettingsFormSchema'

export const OfflinePayment = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  const handleDebouncedOfflinePaymentInputChange = useDebouncedCallback(() =>
    trackInvoicingSettings('Offline payment typed'),
  )

  return (
    <FormItem
      name="paymentMethods.offlinePayment"
      render={({ field: { onChange, ...rest } }) => (
        <Input
          {...rest}
          onChange={(event) => {
            onChange(event)
            handleDebouncedOfflinePaymentInputChange()
          }}
          placeholder={t('settings.organization.external_invoice.payment_methods.offline_payment.placeholder')}
        />
      )}
    />
  )
}
